import { useTranslation } from 'react-i18next'

import { CalendarDayIcon } from '@pleio/icons/calendar-day'

import DropdownButton from 'js/components/DropdownButton'
import IconButton from 'js/components/IconButton'

import useAddToCalendar from './useAddToCalendar'

export type AddToCalendarEntity = {
    title: string
    excerpt?: string | null
    startDate: string | null
    endDate?: string | null
    location?: string | null
    locationAddress?: string | null
    locationLink?: string | null
    videoCallUrl?: string | null
}

export type AddToCalendarSite = {
    integratedVideocallEnabled?: boolean
}

export type AddToCalendarProps = {
    entity: AddToCalendarEntity
    site: AddToCalendarSite
}

const AddToCalendar = ({ entity, site }: AddToCalendarProps) => {
    const { t } = useTranslation()

    const { options } = useAddToCalendar({ entity, site, window, navigator })

    return (
        <DropdownButton
            options={options}
            side="bottom"
            align="center"
            className="EventAction"
        >
            <IconButton
                variant="primary"
                radiusStyle="rounded"
                className="EventActionButton"
            >
                <CalendarDayIcon />
                {t('entity-event.save-to-cal')}
            </IconButton>
        </DropdownButton>
    )
}

export default AddToCalendar
